import React from "react";
import Link from "components/MDX/Link";
import classnames from "classnames";

const DEFAULT_CLASSES = {
  list: "list pa0 ma0",
  block: "lh-copy pt1 f6",
  link: "fw6 color-primary link__decoration--hover"
};

const TOKEN = "token";
const CODE = "code";
const SPAN_TYPE = {
  TOKEN,
  CODE
};

const Paragraphs = ({ paragraphs = [], customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const nodes = paragraphs.map((paragraph, paraIx) => {
    const isLast = paragraphs.length - 1 === paraIx;

    const spanNodes = paragraph.map(({ copy, href, type }, spanIx) => {
      const spanKey = `${paraIx}.${spanIx}`;
      const spanClass = spanIx ? "pl1" : "";

      if (href) {
        return (
          <Link key={spanKey} href={href} className={classes.link}>
            <span className={spanClass}>{copy}</span>
          </Link>
        );
      } else {
        if (type === SPAN_TYPE.TOKEN || type === SPAN_TYPE.CODE) {
          return (
            <span
              style={{ width: "fit-content" }}
              className={`${spanClass} token-monospace ba br1 hairline-1 f6 ml1`}
              key={spanKey}
            >
              {copy}
            </span>
          );
        } else {
          return (
            <span className={spanClass} key={spanKey}>
              {copy}
            </span>
          );
        }
      }
    });

    return (
      <li key={paraIx} className={classnames(classes.block, { pb2: !isLast })}>
        {spanNodes}
      </li>
    );
  });

  return <ul className={classes.list}>{nodes}</ul>;
};

export default Paragraphs;
